import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormGroupModule } from '../../chords/form-group/form-group.module';

import { ButtonModule } from '../../notes/button/button.module';
import { CardModule } from '../../notes/card/card.module';
import { IconModule } from '../../notes/icon/icon.module';

import { AuthenticationComponent } from './authentication.component';

@NgModule({
  declarations: [AuthenticationComponent],
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
    FormGroupModule,
    IconModule,
  ],
  exports: [AuthenticationComponent],
})
export class AuthenticationModule {}
